const existsWithLength = (val) => typeof val !== 'undefined' && val.length > 0;

export default existsWithLength;
